import actions from './actions';

const {
  GET_CAR_BRAND_BEGIN, GET_CAR_BRAND_SUCCESS, GET_CAR_BRAND_FAILED,
  GET_ONLY_CAR_BRAND_BEGIN, GET_ONLY_CAR_BRAND_SUCCESS, GET_ONLY_CAR_BRAND_FAILED,
  ADD_BRAND_BEGIN, ADD_BRAND_SUCCESS, ADD_BRAND_FAILED,
  UPDATE_BRAND_BEGIN, UPDATE_BRAND_SUCCESS, UPDATE_BRAND_FAILED,
  DELETE_BRAND_BEGIN, DELETE_BRAND_SUCCESS, DELETE_BRAND_FAILED
} = actions;

const initState = {
  carBrands: [],
  brands: [],
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null
};

const CarBrandReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_CAR_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_CAR_BRAND_SUCCESS:
      return {
        ...state,
        brands: data.brands,
        total: data.total || 0,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.currentPage ? false : true,
      };
    case GET_CAR_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_ONLY_CAR_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_ONLY_CAR_BRAND_SUCCESS:
      return {
        ...state,
        carBrands: data,
        loading: false,
      };
    case GET_ONLY_CAR_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_BRAND_SUCCESS:
      return {
        ...state,
        brands: data,
        total: state.total + 1,
        loading: false,
      };
    case ADD_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_BRAND_SUCCESS:
      return {
        ...state,
        brands: data,
        loading: false,
      };
    case UPDATE_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_BRAND_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_BRAND_SUCCESS:
      return {
        ...state,
        brands: data,
        total: state.total - 1,
        loading: false,
      };
    case DELETE_BRAND_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default CarBrandReducer;